import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { IChatSuggestion } from '@fi-shared/fi-chat/fi-chat';
import { ILightWeightUser } from '@fi-shared/models';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-chat-conversation-suggestion-item',
    template: `
        <p class="fi-chat-conversation-suggestion-item-name bold">{{ getSuggestionName() }}</p>
        <fi-chat-conversation-users-list
            [users]="suggestedConversation.Users"
            [isRippleEffect]="false"
            (onUserCardClick)="onUserCardClick($event)"
        >
        </fi-chat-conversation-users-list>
    `,
    styleUrls: ['./fi-chat-conversation-suggestion-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-chat-conversation-suggestion-item' },
    standalone: false,
})
export class FiChatConversationSuggestionItemComponent {
    @Input() suggestedConversation: IChatSuggestion;
    @Output() openNewChatWindow = new EventEmitter<ILightWeightUser>();

    constructor(private appTextService: AppTextService) {}

    onUserCardClick(user: ILightWeightUser) {
        this.openNewChatWindow.emit(user);
    }

    getSuggestionName() {
        if (this.suggestedConversation.SuggestionName)
            return this.appTextService.get('chat.suggested_unit', {
                '{0}': this.suggestedConversation.SuggestionName,
            });
        return this.appTextService.get('chat.more_suggestions');
    }
}
